import { ENABLE_ESHOP_SUBSCRIBE } from "@helper/getEnvVariables";
import { useEshopSubscribeCta } from "@helper/useEshopSubscribeCta";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import cx from "classnames";
import React from "react";

import { FooterMenuDetails } from "./footerMenuConstants";
import { FooterMenuType } from "./footerMenuType";

type FooterMenuListProps = {
  testId: string;
  items: FooterMenuDetails[];
  type: FooterMenuType;
};

export function FooterMenuList({ testId, items, type }: FooterMenuListProps) {
  const subscribeCta = useEshopSubscribeCta("subscribe-footer");

  const listStyle = cx(
    "text-text-inverse",
    type === "social" && "flex items-center lg:-mt-[10px]",
    type === "top" && "[&_a]:font-regular",
    type === "eshop" && "[&_a]:font-bold",
    type === "appDownload" && "flex gap-[12px]",
  );

  return (
    <List testId={`${testId}-${type}-footerMenuList`} className={listStyle}>
      {items.map((item: FooterMenuDetails, index: number) => {
        // EMTM-1621: behind the flag, the "Langgan" CTA points to the on-domain
        // subscribe page (subLink) and opens in the same tab, instead of the
        // external link that opened a new tab.
        const isEshopLanggan =
          ENABLE_ESHOP_SUBSCRIBE &&
          item.title === "Langgan" &&
          subscribeCta.isSubscribeAvailable;
        const href = isEshopLanggan ? subscribeCta.href : item.url;
        const openInNewTab = isEshopLanggan ? false : Boolean(item.newTab);
        const onClick = isEshopLanggan ? subscribeCta.onClick : undefined;
        return (
          <React.Fragment key={index}>
            {!(
              !subscribeCta.isSubscribeAvailable && item.title === "Langgan"
            ) && (
              <>
                <ListItem
                  key={`${testId}-item-${index}`}
                  testId={`${testId}-item-${index}`}
                >
                  <a
                    key={index}
                    href={href}
                    target={openInNewTab ? "_blank" : "_self"}
                    onClick={onClick}
                    rel="noopener noreferrer"
                    className={cx(
                      "text-xs font-primary lead-[150%] font-light hover:underline",
                      type === "social" &&
                        index === 5 &&
                        "p-1.5 flex justify-end",
                    )}
                  >
                    {item.title ? item.title : null}
                    {item.images ? (
                      <img
                        src={item.images}
                        alt={`${item.title || item.alt}-menu-icon`}
                      />
                    ) : null}
                  </a>
                </ListItem>
              </>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );
}
